import Swiper from "swiper/bundle";

const showModal = (modal) => {
  // Store the element that had focus before opening the modal
  const previouslyFocused = document.activeElement;
  modal.previouslyFocused = previouslyFocused;

  modal.removeAttribute("hidden");
  modal.style.opacity = "1";
  modal.style.pointerEvents = "all";
  const modalContent = modal.querySelector(".modal-content");
  modalContent.style.opacity = "1";
  modalContent.style.transform = "translateY(0)";
  modal.showModal();

  // Focus the close button or the first focusable element
  const closeButton = modal.querySelector("#close-modal");
  if (closeButton) {
    closeButton.focus();
  }
};

const hideModal = (modal) => {
  modal.style.opacity = "0";
  modal.querySelector(".modal-content").style.opacity = "0";
  modal.querySelector(".modal-content").style.transform = "translateY(20px)";
  setTimeout(() => {
    modal.style.pointerEvents = "none";
    modal.setAttribute("hidden", "");
    modal.close();
    document.body.style.overflow = "";

    // Return focus to the element that had focus before the modal was opened
    if (modal.previouslyFocused) {
      modal.previouslyFocused.focus();
    }
  }, 200);
};

// Attach event listeners to open modal buttons.
document.querySelectorAll(".open-modal-btn").forEach((button) => {
  button.addEventListener("click", () => {
    const modalId = button.getAttribute("data-modal-target");
    const modal = document.querySelector(modalId);
    showModal(modal);
  });
});

// Attach event listeners to close modal buttons.
document.querySelectorAll('[id^="close-modal"]').forEach((button) => {
  button.addEventListener("click", () => {
    const modal = button.closest(".modal-backdrop");
    hideModal(modal);
  });
});

// Close modals with the Escape key and clicking outside modal content.
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    document
      .querySelectorAll('.modal-backdrop[aria-hidden="false"]')
      .forEach((modal) => {
        hideModal(modal);
      });
  }
});

document.querySelectorAll(".modal-backdrop").forEach((modalBackdrop) => {
  modalBackdrop.addEventListener("click", (event) => {
    if (event.target === modalBackdrop) {
      hideModal(modalBackdrop);
    }
  });
});

// Function to create the overlay div.
function createOverlay() {
  var overlay = document.createElement("div");
  overlay.id = "overlay";
  overlay.className = "overlay";
  document.body.appendChild(overlay);
  return overlay;
}
var overlay = createOverlay();

// Add a click event listener to the hamburger button.
const hamburgerButtonArea = document.getElementById("nav-toggle");
const hamburgerButton = document.getElementById("burger-icon");
hamburgerButtonArea.addEventListener("click", function () {
  document.body.classList.toggle("nav-open");
  hamburgerButton.classList.toggle("open");
});

// Add a click event listener to the overlay to close the navigation.
overlay.addEventListener("click", function () {
  document.body.classList.remove("nav-open");
  hamburgerButton.classList.remove("open");
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".mySwiper").forEach((el) => {
    new Swiper(el, {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: false,
      loop: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      centeredSlides: false,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  });
});

// Accordion item block.
document.addEventListener("DOMContentLoaded", function () {
  var accItems = document.querySelectorAll(".accordion-item");

  function toggleAccordion(header) {
    var item = header.parentNode;
    var content = header.nextElementSibling;

    // Toggle the current accordion
    item.classList.toggle("open");
    content.style.maxHeight = item.classList.contains("open")
      ? content.scrollHeight + "px"
      : null;
  }

  // Function to close all accordion items
  function closeAllAccordions(except = null) {
    accItems.forEach(function (item) {
      if (item !== except) {
        item.classList.remove("open");
        var content = item.querySelector(".accordion-content");
        content.style.maxHeight = null;
      }
    });
  }

  // Attach click event listeners to each accordion header
  accItems.forEach(function (item) {
    item
      .querySelector(".accordion-header")
      .addEventListener("click", function () {
        closeAllAccordions(item);
        toggleAccordion(this);
      });
  });

  // Open the accordion items marked for opening on load
  accItems.forEach(function (item) {
    if (item.classList.contains("open-on-load")) {
      item.classList.add("open");
      var content = item.querySelector(".accordion-content");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });

  // Custom smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");
      e.preventDefault();

      // Skip empty anchors or just "#"
      if (!targetId || targetId === "#") {
        return;
      }

      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        // Check if the target element is an accordion item header
        const isAccordionItem =
          targetElement.classList.contains("accordion-item");

        if (isAccordionItem) {
          // Handle accordion item: Close all others and toggle the clicked one
          closeAllAccordions(targetElement);
          if (!targetElement.classList.contains("open")) {
            toggleAccordion(targetElement.querySelector(".accordion-header"));
          }
        }

        // Scroll to the target element (accordion or not)
        setTimeout(
          function () {
            targetElement.scrollIntoView({
              behavior: "smooth",
              block: "start", // Optionally add block to control alignment
            });
          },
          isAccordionItem ? 300 : 0
        ); // Adjust delay if needed for accordions
      }
    });
  });
});

// Accordion item block.
document.addEventListener("DOMContentLoaded", function () {
  var accItems = document.querySelectorAll(".course-accordion-item");
  function toggleAccordion(header) {
    var item = header.parentNode;
    var content = header.nextElementSibling;

    // Toggle the current accordion
    item.classList.toggle("open");
    content.style.maxHeight = item.classList.contains("open")
      ? content.scrollHeight + "px"
      : null;
  }
  // Attach click event listeners to each accordion header
  accItems.forEach(function (item) {
    item.querySelector("h2").addEventListener("click", function () {
      toggleAccordion(this);
    });
  });
});

// Define a throttle function
function throttle(func, limit) {
  // Variable to keep track of whether the function is currently throttled
  let inThrottle;

  // Return a new function that wraps the original function
  return function () {
    // Save the arguments and context for later use
    const args = arguments;
    const context = this;

    // If the function is not currently throttled, execute it
    if (!inThrottle) {
      func.apply(context, args);
      // Set the throttle flag to true
      inThrottle = true;
      // After the limit period, reset the throttle flag
      setTimeout(() => (inThrottle = false), limit);
    }
  };
}

// Wait until the DOM is fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // Variables to store the last scroll position and the threshold for hiding the header
  var lastScrollTop = 0;
  var headerHideThreshold = 400;

  // Get references to the header and admin bar elements
  var header = document.getElementById("main-header");
  var adminBar = document.getElementById("wpadminbar");

  // Calculate the height of the admin bar
  var adminBarHeight = adminBar ? adminBar.offsetHeight : 0;

  // Add the 'at-top' class to the header
  header.classList.add("at-top");

  // Adjust the initial position of the header
  header.style.top = adminBarHeight + "px";

  // Listen for scroll events
  window.addEventListener(
    "scroll",
    function () {
      // Get the current scroll position
      var currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;
      var isAtTop = currentScroll <= 100;

      // If the user is at the top of the page, add the 'at-top' class
      if (isAtTop) {
        header.classList.add("at-top");
      } else {
        // Otherwise, remove the 'at-top' class
        header.classList.remove("at-top");
      }

      // Check if the user has scrolled to the bottom of the page
      var isBottomOfPage =
        Math.ceil(window.scrollY) >=
        document.body.scrollHeight - window.innerHeight;

      // If the user is scrolling down and not at the bottom of the page, hide the header
      if (
        currentScroll > lastScrollTop &&
        currentScroll > headerHideThreshold &&
        !isBottomOfPage
      ) {
        header.style.top = "-" + (header.offsetHeight + adminBarHeight) + "px";
      }
      // If the user is scrolling up or at the bottom of the page, show the header
      else if (currentScroll < lastScrollTop || isBottomOfPage) {
        header.style.top = adminBarHeight + "px";
      }

      // Update the last scroll position
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    },
    false
  );
});

// Function to check if element is in viewport
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Function to animate digits
function animateDigits(element, delay) {
  setTimeout(() => {
    // Extract the full initial text, including any +, -, or % characters
    const fullText = element.getAttribute("data-final-text");
    // Use a regex to extract just the numeric part for animation
    const numberMatch = fullText.match(/-?\d+/);
    const end = numberMatch ? parseInt(numberMatch[0], 10) : 0;
    const start = 0;
    const duration = 1000;
    const startTime = performance.now();

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const currentNumber = Math.round(start + (end - start) * progress);
      // Update the element's text content, preserving the original characters
      element.textContent = fullText.replace(/-?\d+/, currentNumber);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }, delay);
}

// Function to handle scroll event
function handleScroll() {
  const elements = document.querySelectorAll(".animate-nr");
  elements.forEach((element, index) => {
    if (isInViewport(element) && !element.classList.contains("animated")) {
      element.classList.add("animated");
      const delay = index * 0; // 200ms delay per block
      animateDigits(element, delay);
    }
  });
}

// Initialize elements with final numbers and set their text content to 0, preserving +, -, or %
function initializeAnimationTargets() {
  const elements = document.querySelectorAll(".animate-nr");
  elements.forEach((element) => {
    const fullText = element.textContent;
    // Set the full original text as an attribute for later use
    element.setAttribute("data-final-text", fullText);
    // Use regex to find numbers, ensuring at least one match is found, otherwise default to "0"
    const matches = fullText.match(/-?\d+/);
    const initialNumber = matches && matches.length > 0 ? matches[0] : "0";
    // Replace the numeric part in the original text with "0" for the initial state
    element.textContent = fullText.replace(/-?\d+/, "0");
  });
}

// Add event listener for scroll event
window.addEventListener("scroll", handleScroll);

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    // Add a slight delay to allow the layout to stabilize
    initializeAnimationTargets();
    handleScroll(); // Check if elements are in viewport initially
  }, 100); // 100 milliseconds delay should be enough
});

document.addEventListener("DOMContentLoaded", function () {
  const syllabusContents = document.querySelectorAll(".syllabus-content");

  syllabusContents.forEach((content, index) => {
    const h2 = content.querySelector("h2");
    const ul = content.querySelector("ul");

    // Function to expand syllabus
    const expandSyllabus = () => {
      content.classList.add("expanded");
      ul.style.maxHeight = ul.scrollHeight + "px";
    };

    // Function to collapse syllabus
    const collapseSyllabus = () => {
      content.classList.remove("expanded");
      ul.style.maxHeight = "0px";
    };

    // Initially collapse all ULs except the first one
    if (index === 0) {
      expandSyllabus();
    } else {
      collapseSyllabus();
    }

    h2.addEventListener("click", function () {
      if (content.classList.contains("expanded")) {
        collapseSyllabus();
      } else {
        expandSyllabus();
      }
    });
  });
});

// Rating.
// Rating.
document.addEventListener("DOMContentLoaded", function () {
  const ratingContainers = document.querySelectorAll(".academie-rating");

  ratingContainers.forEach(initRating);

  function initRating(container) {
    const starsContainer = container.querySelector(".stars");
    const { postId, ajaxUrl, nonce } = container.dataset;

    // Get the current rating from data attribute if available
    let currentRating = parseFloat(container.dataset.currentRating || 0);

    starsContainer.addEventListener("mouseover", (e) => {
      const star = e.target.closest(".star");
      if (star) highlightStars(container, star.dataset.rating);
    });

    starsContainer.addEventListener("mouseout", (e) => {
      // Use the stored current rating
      highlightStars(container, currentRating);
    });

    starsContainer.addEventListener("click", (e) => {
      const star = e.target.closest(".star");
      if (star) submitRating(star.dataset.rating);
    });

    function submitRating(rating) {
      const formData = new FormData();
      formData.append("action", "submit_academie_rating");
      formData.append("nonce", nonce);
      formData.append("post_id", postId);
      formData.append("rating", rating);

      // Get the message container
      const messageContainer = container.querySelector(".rating-message");

      // Clear any existing timeouts for this container
      if (messageContainer.hideTimeout) {
        clearTimeout(messageContainer.hideTimeout);
        messageContainer.hideTimeout = null;
      }
      if (messageContainer.cleanupTimeout) {
        clearTimeout(messageContainer.cleanupTimeout);
        messageContainer.cleanupTimeout = null;
      }

      fetch(ajaxUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            // Update the stored current rating with the raw value
            currentRating = data.data.raw_average;
            container.dataset.currentRating = currentRating;

            // Update the display
            updateRatingDisplay(container, data.data);

            // Show the success message - reset any ongoing animations first
            messageContainer.style.transition = "none"; // Temporarily disable transitions
            messageContainer.offsetHeight; // Force reflow

            // Set content and prepare for showing
            messageContainer.textContent = data.data.message;
            messageContainer.style.height = "auto";

            // Re-enable transitions and show
            messageContainer.style.transition = "";
            messageContainer.offsetHeight; // Force reflow
            messageContainer.classList.add("active");

            // Hide the message after 3 seconds
            messageContainer.hideTimeout = setTimeout(() => {
              // Get the computed height before collapsing
              const height = messageContainer.offsetHeight;

              // Set the explicit height to enable smooth transition to zero
              messageContainer.style.height = height + "px";
              messageContainer.offsetHeight; // Force reflow

              // Remove active class and animate to zero height
              messageContainer.classList.remove("active");
              messageContainer.style.height = "0";

              // Clean up after transition
              messageContainer.cleanupTimeout = setTimeout(() => {
                messageContainer.textContent = "";
                messageContainer.style.height = "";
              }, 300); // Match this to your CSS transition time
            }, 3000);
          }
        })
        .catch((error) => {
          console.error("Rating submission error:", error);
        });
    }
  }

  function updateRatingDisplay(container, data) {
    // Use raw_average for star display if available
    const rawAverage =
      data.raw_average || parseFloat(data.new_average.replace(",", "."));

    // Update stars with the raw value
    updateStars(container, rawAverage);

    // Get the post title from data attribute
    const postTitle = container.dataset.title;

    // Get template from data attribute instead of hidden element
    const template = container.dataset.templateHasRatings;

    if (!template) {
      console.error("Rating template not found!");
      return;
    }

    // Replace placeholders in the template
    let newRatingHtml = template.replace(/%s/, postTitle);
    newRatingHtml = newRatingHtml.replace(/%s/, data.new_average);
    newRatingHtml = newRatingHtml.replace(/%d/, data.new_count);

    // Update the rating data section
    container.querySelector("#rating-data").innerHTML = newRatingHtml;
  }

  function updateStars(container, rating) {
    const stars = container.querySelectorAll(".stars .star");
    stars.forEach((starContainer, index) => {
      const star = starContainer.querySelector("i");
      if (rating >= index + 1) {
        // Full star
        star.className = "fas fa-star";
      } else if (rating > index && rating < index + 1) {
        // Half star
        star.className = "fas fa-star-half-alt";
      } else {
        // Empty star
        star.className = "far fa-star";
      }
    });
  }

  function highlightStars(container, rating) {
    updateStars(container, rating);
  }
});

// Swiper for article-list displays.
// Swiper for article-list displays.
// Swiper for article-list displays.
// Swiper for article-list displays.
// Swiper for article-list displays.
document.addEventListener("DOMContentLoaded", function () {
  let resizeTimeout;

  function initializeSwipers() {
    document.querySelectorAll(".articleListSwiper").forEach((el) => {
      const desktopThreshold = parseInt(el.dataset.desktopThreshold) || 4;
      const tabletThreshold = parseInt(el.dataset.tabletThreshold) || 3;
      const mobileThreshold = parseInt(el.dataset.mobileThreshold) || 2;
      const itemsCount = parseInt(el.dataset.itemsCount) || 0;

      let enableSwiper = false;
      let applyPeeking = false;
      let screenWidth = window.innerWidth;
      let currentThreshold;

      // Determine current breakpoint and whether slider is needed
      if (screenWidth < 640) {
        currentThreshold = mobileThreshold;
        enableSwiper = itemsCount > mobileThreshold;
        applyPeeking = itemsCount > mobileThreshold;
      } else if (screenWidth < 1024) {
        currentThreshold = tabletThreshold;
        enableSwiper = itemsCount > tabletThreshold;
        applyPeeking = itemsCount > tabletThreshold;
      } else {
        currentThreshold = desktopThreshold;
        enableSwiper = itemsCount > desktopThreshold;
        applyPeeking = itemsCount > desktopThreshold;
      }

      const articleList = el.closest(".article-list");

      // Destroy existing Swiper instance first
      if (el.swiper) {
        el.swiper.destroy(true, true);
        el.classList.remove("swiper-initialized");
      }

      // Apply or remove swiper classes based on current breakpoint needs
      if (applyPeeking) {
        articleList.classList.add("swiper-enabled");
      } else {
        articleList.classList.remove("swiper-enabled");
      }

      // If slider is not needed for current breakpoint, show as normal grid
      if (!enableSwiper) {
        // Reset any swiper-specific styling and SHOW CONTENT
        el.style.opacity = "1"; // KEY FIX: Set full opacity immediately
        el.classList.remove("swiper-initialized");
        el.classList.add("swiper-disabled"); // Add class to indicate no swiper

        // Convert swiper structure back to grid if needed
        const wrapper = el.querySelector(".swiper-wrapper");
        if (wrapper) {
          wrapper.style.display = "grid";
          wrapper.style.gridTemplateColumns = "";
          wrapper.style.gap = "";
        }

        return; // Exit early - no Swiper needed
      }

      // Remove disabled class if we're enabling swiper
      el.classList.remove("swiper-disabled");

      // Reset container styles before initialization
      el.style.width = "";
      el.style.maxWidth = "";
      el.style.opacity = "0.1"; // Set initial opacity only when initializing

      // Reset wrapper to flex for swiper
      const wrapper = el.querySelector(".swiper-wrapper");
      if (wrapper) {
        wrapper.style.display = "flex";
        wrapper.style.gridTemplateColumns = "none";
        wrapper.style.gap = "0";
      }

      // Trigger reflow
      el.offsetHeight;

      // Initialize Swiper
      const swiper = new Swiper(el, {
        slidesPerView: Math.min(itemsCount, currentThreshold),
        spaceBetween: 20,
        pagination: false,
        loop: false,
        centeredSlides: false,
        slidesOffsetBefore: applyPeeking ? 30 : 0,
        slidesOffsetAfter: applyPeeking ? 30 : 0,
        allowTouchMove: enableSwiper,

        calculateHeight: true,
        roundLengths: true,

        breakpoints: {
          0: {
            slidesPerView: Math.min(itemsCount, mobileThreshold),
            slidesOffsetBefore: itemsCount > mobileThreshold ? 30 : 0,
            slidesOffsetAfter: itemsCount > mobileThreshold ? 30 : 0,
            allowTouchMove: itemsCount > mobileThreshold,
          },
          640: {
            slidesPerView: Math.min(itemsCount, tabletThreshold),
            slidesOffsetBefore: itemsCount > tabletThreshold ? 30 : 0,
            slidesOffsetAfter: itemsCount > tabletThreshold ? 30 : 0,
            allowTouchMove: itemsCount > tabletThreshold,
          },
          1024: {
            slidesPerView: Math.min(itemsCount, desktopThreshold),
            slidesOffsetBefore: itemsCount > desktopThreshold ? 30 : 0,
            slidesOffsetAfter: itemsCount > desktopThreshold ? 30 : 0,
            allowTouchMove: itemsCount > desktopThreshold,
          },
        },
        on: {
          init: function () {
            this.el.style.width = "100%";
            this.el.style.maxWidth = "100%";
            this.el.style.opacity = "1"; // Show with full opacity
            this.el.classList.add("swiper-initialized");
          },
          resize: function () {
            this.el.style.width = "100%";
            this.el.style.maxWidth = "100%";
            this.update();
          },
        },
      });
    });
  }

  // Initialize on load
  initializeSwipers();

  // Improved resize handler
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initializeSwipers();
    }, 300);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const breadcrumbList = document.querySelector(".breadcrumbs ol");

  if (breadcrumbList) {
    // Use 'requestAnimationFrame' to ensure it's applied after rendering
    requestAnimationFrame(() => {
      breadcrumbList.scrollLeft = breadcrumbList.scrollWidth;
    });
  }
});
// Plan selection for HubSpot forms - Final streamlined version
document.addEventListener("DOMContentLoaded", function () {
  // Global variable to store the selected plan
  window.selectedPlan = null;

  // Track the last value we set to avoid duplicate updates
  let lastSetValue = null;

  // Function to update a form with the plan or clear it
  function updatePlanField(form) {
    const planField = form.querySelector('input[name="selected_plan"]');
    if (!planField) return;

    const newValue = window.selectedPlan || "";

    // Only update if the value has changed
    if (planField.value !== newValue) {
      planField.value = newValue;

      if (window.selectedPlan) {
        console.log("Form field updated with plan:", window.selectedPlan);
      } else {
        console.log("Form field cleared");
      }
    }
  }

  // Update all HubSpot forms on the page
  function updateFormsOnPage() {
    document.querySelectorAll("form.hs-form").forEach(updatePlanField);

    // Also check for forms in iframes
    document.querySelectorAll("iframe").forEach((iframe) => {
      try {
        if (iframe.contentDocument) {
          iframe.contentDocument
            .querySelectorAll("form.hs-form")
            .forEach(updatePlanField);
        }
      } catch (e) {} // Silently handle cross-origin restrictions
    });
  }

  // Handle clicks on all modal buttons
  document.addEventListener("click", function (e) {
    const button = e.target.closest(".open-modal-btn");
    if (!button) return;

    // If the button has data-plan, store it - otherwise clear it
    window.selectedPlan = button.dataset.plan || null;

    if (window.selectedPlan) {
      console.log("Plan set:", window.selectedPlan);
    } else {
      console.log("No plan data found, clearing plan selection");
    }

    // Update forms after button click
    setTimeout(updateFormsOnPage, 300);
    setTimeout(updateFormsOnPage, 600);
  });

  // HubSpot form integration - handle form ready events
  window.addEventListener("message", function (event) {
    try {
      if (
        event.data?.type === "hsFormCallback" &&
        event.data?.eventName === "onFormReady"
      ) {
        console.log("HubSpot form ready event received");
        // Update forms when they're ready
        setTimeout(updateFormsOnPage, 100);
      }
    } catch (e) {}
  });

  // Catch any forms that load on page initialization
  setTimeout(updateFormsOnPage, 1000);
});

// ENHANCED LIVE SEARCH SYSTEM - SIMPLIFIED VERSION
document.addEventListener("DOMContentLoaded", function () {
  // ============================================================================
  // STATE MANAGEMENT
  // ============================================================================

  let searchTimeout;
  let activeRequest = null;
  let lastSearchTerm = "";
  let cachedResults = new Map();

  // ============================================================================
  // UTILITY FUNCTIONS
  // ============================================================================

  /**
   * Generates a unique cache key for search results
   * Normalizes search term to lowercase and trims whitespace for better cache hits
   */
  const getCacheKey = (container, searchTerm) => {
    const form = container.querySelector(".custom-search-form");

    const postTypes = Array.from(form.querySelectorAll(".js-post-type"))
      .map((input) => input.dataset.value)
      .sort()
      .join(",");

    const taxonomies = Array.from(form.querySelectorAll(".js-taxonomy"))
      .map((input) => input.dataset.value)
      .sort()
      .join(",");

    // Normalize search term: lowercase and trim whitespace
    const normalizedSearchTerm = searchTerm.toLowerCase().trim();

    return `${normalizedSearchTerm}|${postTypes}|${taxonomies}`;
  };

  /**
   * Shows/hides search results with consistent behavior
   */
  const toggleResults = (container, show = true) => {
    container.style.display = show ? "block" : "none";
  };

  /**
   * Displays cached or existing results if available
   * Uses normalized search terms for better cache matching
   */
  const showCachedResults = (container, searchTerm) => {
    const resultsContainer = container.querySelector(
      ".live-search-results-container"
    );

    if (searchTerm.length < 2) return false;

    const cacheKey = getCacheKey(container, searchTerm); // This now uses normalized term

    // First priority: cached results
    if (cachedResults.has(cacheKey)) {
      resultsContainer.innerHTML = cachedResults.get(cacheKey);
      toggleResults(resultsContainer, true);
      return true;
    }

    // Second priority: existing results that match current search
    // Normalize both terms for comparison
    const normalizedCurrent = searchTerm.toLowerCase().trim();
    const normalizedLast = lastSearchTerm.toLowerCase().trim();

    if (
      normalizedCurrent === normalizedLast &&
      resultsContainer.innerHTML.trim() !== ""
    ) {
      toggleResults(resultsContainer, true);
      return true;
    }

    return false;
  };

  // ============================================================================
  // MAIN SEARCH FUNCTION
  // ============================================================================

  /**
   * Performs the actual AJAX search request using modern fetch() API
   */
  async function performLiveSearch(container, searchTerm) {
    const form = container.querySelector(".custom-search-form");
    const resultsContainer = container.querySelector(
      ".live-search-results-container"
    );

    // Extract search configuration
    const postTypes = Array.from(form.querySelectorAll(".js-post-type")).map(
      (input) => input.dataset.value
    );
    const taxonomies = Array.from(form.querySelectorAll(".js-taxonomy")).map(
      (input) => input.dataset.value
    );

    // Prepare FormData
    const formData = new FormData();
    formData.append("action", "custom_live_search");
    formData.append("search_term", searchTerm);
    formData.append("nonce", customSearch.nonce);

    postTypes.forEach((type) => formData.append("post_types[]", type));
    taxonomies.forEach((tax) => formData.append("taxonomies[]", tax));

    try {
      // Create AbortController for request cancellation
      const controller = new AbortController();
      activeRequest = controller;

      const response = await fetch(customSearch.ajaxurl, {
        method: "POST",
        body: formData,
        signal: controller.signal,
      });

      container.classList.remove("searching");

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseText = await response.text();
      resultsContainer.innerHTML = responseText;
      toggleResults(resultsContainer, true);

      // Cache management
      const cacheKey = getCacheKey(container, searchTerm);
      cachedResults.set(cacheKey, responseText);

      // Memory management - limit cache size
      if (cachedResults.size > 20) {
        const firstKey = cachedResults.keys().next().value;
        cachedResults.delete(firstKey);
      }

      lastSearchTerm = searchTerm.toLowerCase().trim();
    } catch (error) {
      container.classList.remove("searching");

      if (error.name === "AbortError") return;

      const errorMessage =
        '<div class="search-error">Search error occurred. Please try again.</div>';
      resultsContainer.innerHTML = errorMessage;
      toggleResults(resultsContainer, true);

      console.error("Search error:", error);
    } finally {
      activeRequest = null;
    }
  }

  // ============================================================================
  // EVENT HANDLERS
  // ============================================================================

  /**
   * Unified input/focus/click handler for search inputs
   */
  const handleSearchInput = (e, isTyping = false) => {
    if (!e.target.classList.contains("custom-search-input")) return;

    const input = e.target;
    const container = input.closest(".custom-search-container");
    const searchTerm = input.value.trim();

    // Cancel any pending operations
    clearTimeout(searchTimeout);
    if (activeRequest) {
      activeRequest.abort();
      activeRequest = null;
    }

    // Handle short search terms
    if (searchTerm.length < 2) {
      const resultsContainer = container.querySelector(
        ".live-search-results-container"
      );
      toggleResults(resultsContainer, false);
      container.classList.remove("searching");
      lastSearchTerm = "";
      return;
    }

    // Try to show cached results first
    if (showCachedResults(container, searchTerm)) {
      return;
    }

    // Only perform new search if user is typing
    if (isTyping) {
      container.classList.add("searching");

      // Debounce the search
      searchTimeout = setTimeout(() => {
        performLiveSearch(container, searchTerm);
      }, 300);
    }
  };

  // ============================================================================
  // EVENT LISTENERS
  // ============================================================================

  // Input handler with debouncing
  document.addEventListener("input", (e) => handleSearchInput(e, true));

  // Focus and click handlers (no debouncing needed)
  document.addEventListener("focus", (e) => handleSearchInput(e, false), true);
  document.addEventListener("click", (e) => handleSearchInput(e, false));

  // Outside click handler - hide all results
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".custom-search-container")) {
      document
        .querySelectorAll(".live-search-results-container")
        .forEach((container) => toggleResults(container, false));
    }
  });

  // ESC key handler
  document.addEventListener("keydown", function (e) {
    if (
      e.key === "Escape" &&
      e.target.classList.contains("custom-search-input")
    ) {
      const container = e.target.closest(".custom-search-container");
      const resultsContainer = container.querySelector(
        ".live-search-results-container"
      );
      toggleResults(resultsContainer, false);
      container.classList.remove("searching");
    }
  });
});

// Mob slide.
document.addEventListener("DOMContentLoaded", function () {
  function initializeMobileSliders() {
    document
      .querySelectorAll('[data-mobile-slider="true"]')
      .forEach((element) => {
        const isMobile = window.innerWidth <= 640;
        const isAlreadyWrapped =
          element.parentElement?.classList.contains("swiper");

        if (isMobile && !element.swiper && !isAlreadyWrapped) {
          const slidesPerView = parseInt(element.dataset.slidesPerView) || 1;

          // Set up swiper DOM structure
          element.classList.add("swiper-wrapper");
          Array.from(element.children).forEach((li) =>
            li.classList.add("swiper-slide")
          );

          const swiperContainer = document.createElement("div");
          swiperContainer.className = "swiper";
          element.parentNode.insertBefore(swiperContainer, element);
          swiperContainer.appendChild(element);

          const pagination = document.createElement("div");
          pagination.className = "swiper-pagination section-swiper";
          swiperContainer.appendChild(pagination);

          const swiperInstance = new Swiper(swiperContainer, {
            slidesPerView: slidesPerView,
            spaceBetween: 10,
            grabCursor: true,
            a11y: {
              enabled: true,
              prevSlideMessage: "Previous slide",
              nextSlideMessage: "Next slide",
              paginationBulletMessage: "Go to slide {{index}}",
            },
            pagination: {
              el: pagination,
              clickable: true,
            },
            keyboard: {
              enabled: true,
            },
          });

          swiperContainer.setAttribute("role", "region");
          swiperContainer.setAttribute("aria-label", "Content slider");

          // Store swiper instance on the container
          swiperContainer.__swiperInstance = swiperInstance;
        }

        // DESTROY if no longer mobile
        if (!isMobile && element.closest(".swiper")) {
          const swiperContainer = element.closest(".swiper");
          const swiperInstance = swiperContainer.__swiperInstance;

          if (swiperInstance && swiperInstance.destroy) {
            swiperInstance.destroy(true, true);
          }

          // Cleanup DOM
          Array.from(element.children).forEach((li) =>
            li.classList.remove("swiper-slide")
          );
          element.classList.remove("swiper-wrapper");

          swiperContainer.replaceWith(element); // Move element out of .swiper
        }
      });
  }

  // Run on load
  initializeMobileSliders();

  // Run on resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initializeMobileSliders();
    }, 200); // Throttle
  });
});
